import axios from "axios";

let APP_VERSION = 'dev';
try {
	const versionModule = require('../appVersion');
	APP_VERSION = versionModule.APP_VERSION;
} catch (error) { /* dev */ }

const dispatchVersionUpdate = (serverVersion) => {
	if (typeof window === 'undefined') return;
	window.dispatchEvent(new CustomEvent('app:version-mismatch', {
		detail: { source: 'api', serverVersion }
	}));
};

const api = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	withCredentials: true,
});

api.interceptors.request.use(
	(config) => {
		config.headers['x-app-version'] = APP_VERSION;
		return config;
	},
	(error) => Promise.reject(error)
);

const handleServerVersion = (serverVersion) => {
	if (!serverVersion) return;
	if (process.env.NODE_ENV === 'development') return;
	if (serverVersion === 'dev') return;
	if (APP_VERSION === 'dev') return;
	if (serverVersion !== APP_VERSION) {
		dispatchVersionUpdate(serverVersion);
	}
};

api.interceptors.response.use(
	(response) => {
		handleServerVersion(response.headers['x-app-version']);
		return response;
	},
	(error) => {
		if (error.response) {
			handleServerVersion(error.response.headers['x-app-version']);
		}
		return Promise.reject(error);
	}
);

export const api_nocors = axios.create({
	baseURL: process.env.REACT_APP_BACKEND_URL,
	withCredentials: false,
});

api.postWithProgress = (url, formData, onProgress) => {
	return api.post(url, formData, {
		onUploadProgress: (progressEvent) => {
			if (progressEvent.total) {
				const percentCompleted = Math.round(
					(progressEvent.loaded * 100) / progressEvent.total
				);
				if (onProgress) {
					onProgress(percentCompleted);
				}
			}
		}
	});
};

export default api;
